export default __webpack_public_path__ + "static/media/competition_bg_side.19ac458b.jpg";